export function getOffsetAndLimit(page, resultsPerPage) {
    return {
        limit: resultsPerPage,
        offset: resultsPerPage * (page - 1)
    };
}
export function applyPagedState(state, collection, page, resultsPerPage) {
    state.byPage[page] = collection.map((item) => item.id);
    state.hasNextPage = collection.length === resultsPerPage;
    state.page = page;
}
export function applyPagedPreFetchState(state) {
    state.hasNextPage = false;
}
